document.addEventListener('DOMContentLoaded', function () {
  /* ----------------------------------------
   * Scroll-in reveal
   * ---------------------------------------- */
  var recommendedProductsSection = document.querySelector('.recommended-products');

  if (recommendedProductsSection && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            recommendedProductsSection.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(recommendedProductsSection);
  } else if (recommendedProductsSection) {
    recommendedProductsSection.classList.add('is-visible');
  }

  /* ----------------------------------------
   * Helpers: quick add UI state
   * ---------------------------------------- */
  function setQuickAddState(card, isAvailable) {
    var quickAdd = card.querySelector('.recommended-card__quick-add');
    if (!quickAdd) return;

    var tip = quickAdd.querySelector('.recommended-card__quick-add-tooltip');

    if (isAvailable) {
      quickAdd.classList.remove('is-sold-out');
      quickAdd.removeAttribute('aria-disabled');
      quickAdd.removeAttribute('tabindex');

      var badge = quickAdd.querySelector('.recommended-quick-add-plus');
      if (badge) badge.textContent = '+';

      if (tip) tip.hidden = false;
    } else {
      quickAdd.classList.add('is-sold-out');
      quickAdd.setAttribute('aria-disabled', 'true');
      quickAdd.setAttribute('tabindex', '-1');

      var badge2 = quickAdd.querySelector('.recommended-quick-add-plus');
      if (badge2) badge2.textContent = 'Ç-';

      if (tip) tip.hidden = true;
    }
  }

  function getHandleFromProductUrl(url) {
    if (!url) return '';
    var parts = url.split('/products/');
    if (parts.length < 2) return '';
    var handle = parts[1];
    if (!handle) return '';
    return handle.split('?')[0].split('#')[0];
  }

  /* ----------------------------------------
   * Card hover + colour swatches + Quick add
   * ---------------------------------------- */
  var cards = document.querySelectorAll('.recommended-card');

  cards.forEach(function (card) {
    var frame = card.querySelector('.recommended-card__frame');
    var primaryImg = card.querySelector('.js-recommended-image');
    var swatchButtons = card.querySelectorAll('.recommended-card__swatch-button');
    var quickAdd = card.querySelector('.recommended-card__quick-add');

    // Default variant id (first variant)
    var defaultVariantId = card.getAttribute('data-default-variant-id');

    // Default image src
    var defaultSrc = null;
    if (primaryImg) {
      defaultSrc =
        primaryImg.getAttribute('data-default-image') || primaryImg.getAttribute('src');
    }

    /* ----------------------------------------
     * Disable OOS swatches (based on data-variant-available)
     * + Set default active swatch (first available)
     * ---------------------------------------- */
    var defaultActiveBtn = null;

    swatchButtons.forEach(function (btn) {
      var availableAttr = btn.getAttribute('data-variant-available');
      var isAvailable = availableAttr === 'true';

      if (!isAvailable) {
        btn.classList.add('is-disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('tabindex', '-1');
      } else {
        btn.classList.remove('is-disabled');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('tabindex');

        // pick first available as default active
        if (!defaultActiveBtn) defaultActiveBtn = btn;
      }
    });

    // Apply default active ring
    if (defaultActiveBtn) {
      defaultActiveBtn.classList.add('is-active');
    }

    // Flash only when hovering the IMAGE FRAME (and secondary image exists)
    if (frame && primaryImg) {
      var hasSecondaryImage = !!card.querySelector('.recommended-card__image.is-secondary');
      
      frame.addEventListener('mouseenter', function () {
        if (hasSecondaryImage) {
          card.classList.add('is-flashing');
        }
      });

      frame.addEventListener('mouseleave', function () {
        card.classList.remove('is-flashing');

        // Reset primary image
        if (defaultSrc) primaryImg.setAttribute('src', defaultSrc);

        // Reset active preview back to default (so ring persists)
        swatchButtons.forEach(function (btn) {
          btn.classList.remove('is-active');
        });
        if (defaultActiveBtn) defaultActiveBtn.classList.add('is-active');
      });
    }

    // Swatch hover + click
    swatchButtons.forEach(function (button) {
      button.addEventListener('mouseenter', function () {
        // If disabled, do nothing
        if (button.classList.contains('is-disabled')) return;
        if (!primaryImg) return;
        // Locked-away swatches on exploded tiles have no data-color-name;
        // skip hover effects for them (click-only, keeps the tile's own ring active).
        if (!button.getAttribute('data-color-name')) return;

        var variantImg = button.getAttribute('data-variant-image');

        if (variantImg) {
          primaryImg.setAttribute('src', variantImg);
        } else if (defaultSrc) {
          primaryImg.setAttribute('src', defaultSrc);
        }

        swatchButtons.forEach(function (btn) {
          btn.classList.remove('is-active');
        });
        button.classList.add('is-active');

        card.classList.remove('is-flashing');
      });

      // Click swatch ƒÅ' go to variant URL
      button.addEventListener('click', function () {
        if (button.classList.contains('is-disabled')) return;

        var variantUrl = button.getAttribute('data-variant-url');
        if (variantUrl) {
          window.location.href = variantUrl;
          return;
        }

        var productUrl = card.getAttribute('data-product-url');
        if (productUrl) window.location.href = productUrl;
      });
    });

    // Quick add click (SINGLE source of truth)
    if (quickAdd) {
      quickAdd.addEventListener('click', function (e) {
        var isSoldOut =
          quickAdd.classList.contains('is-sold-out') ||
          quickAdd.getAttribute('aria-disabled') === 'true';

        if (isSoldOut) return;

        var productUrl = card.getAttribute('data-product-url') || '';
        var handle = getHandleFromProductUrl(productUrl);

        // Liquid flag (if it exists)
        var requiresSelection = card.getAttribute('data-requires-selection') === 'true';

        // ƒo. More reliable: if there are swatches, there are variants/choices
        var hasSwatches = !!card.querySelector('.recommended-card__swatches');

        // ƒo. When QuickView is available, open it for anything that looks "selectable"
        // (shoes, colours, multi-variant products)
        var canQuickView = window.QuickView && typeof window.QuickView.open === 'function';
        var shouldOpenQuickView = canQuickView && handle && (requiresSelection || hasSwatches);

        if (shouldOpenQuickView) {
          e.preventDefault();
          window.QuickView.open(handle);
          return;
        }

        // If it's a selectable product but QuickView isn't available, go to PDP
        if ((requiresSelection || hasSwatches) && productUrl) {
          // allow default navigation OR force it:
          // (forcing ensures no weird double-handlers)
          e.preventDefault();
          window.location.href = productUrl;
          return;
        }

        // Non-selectable: ajax add (if CartAPI exists), otherwise allow default navigation
        if (!(window.CartAPI && typeof window.CartAPI.addToCart === 'function')) {
          return;
        }

        e.preventDefault();

        var variantIdToAdd = defaultVariantId;
        if (!variantIdToAdd) return;

        quickAdd.setAttribute('aria-busy', 'true');

        window.CartAPI
          .addToCart({
            items: [{ id: Number(variantIdToAdd), quantity: 1 }]
          })
          .catch(function () {
            var url = card.getAttribute('data-product-url');
            if (url) window.location.href = url;
          })
          .finally(function () {
            quickAdd.removeAttribute('aria-busy');
          });
      });
    }
  });
});
